import styled from '@emotion/styled';
import { Button } from '@presentation/components';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';
import { Container } from '../../components/Container';

export const WarningBanner = styled.div`
  width: 100%;
  background: ${(props) => props.theme.color.red.default};
  color: ${(props) => props.theme.color.light.default};
  text-align: center;
  font-weight: bold;
  padding: 8px 20px;
  position: sticky;
  top: 80px;
  z-index: 2;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);

  ${mediaQuery('small')} {
    font-size: 14px;
  }
`;

export const WarningLabel = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: ${(props) => props.theme.color.red.default};
  white-space: break-spaces;
`;
export const Wrapper = styled.div`
  flex: 1 0 0;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
`;

export const CardContainer = styled(Container)`
  position: relative;
  margin-top: -50px;
  z-index: 1;
  width: 100%;

  display: flex;
  /* max-width: 1140px; */
  align-items: flex-start;
  justify-content: space-between;

  ${mediaQuery('medium')} {
    max-width: 700px;
    align-items: initial;
    flex-direction: column;
  }

  ${mediaQuery('tablet')} {
    max-width: unset;
  }
`;

export const FormCardWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  min-width: 300px;
  margin-left: 10px;
  margin-right: 10px;
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);

  ${mediaQuery('small')} {
    padding: 20px;
    margin-left: 0;
    margin-right: 0;
  }
`;

export const Label = styled.div`
  font-size: 11px;
  font-weight: 800;
  margin-bottom: 10px;
  text-transform: uppercase;
`;

export const Value = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

export const ValueLineBreak = styled.div`
  width: 100%;
`;

export const StepLineWrapper = styled.div`
  padding: 30px 0px;

  ${mediaQuery('small')} {
    padding: 0;
  }
`;

export const BookingAuthWrapper = styled.div`
  height: 100%;
  flex-grow: 1;
`;

export const BookingAuthSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;
  text-align: center;

  width: 100%;
  padding: 40px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);

  ${mediaQuery('small')} {
    padding: 20px;
  }
`;

export const BookingSubtitle = styled.div`
  ${responsiveFontSize(24, 2)};
  font-weight: 700;
  margin-bottom: 20px;
  color: ${(props) => props.theme.color.blue.default};
`;

export const BookingLink = styled.a`
  display: block;
  color: ${(props) => props.theme.color.dark.default};
  margin-top: 20px;
  font-weight: 400;
  &:hover {
    text-decoration: underline;
  }
`;

export const BookingText = styled.p`
  margin: 0;
  margin-top: 20px;
`;

export const BackButtonWrapper = styled.div`
  display: block;
  margin-right: auto;
  color: ${(props) => props.theme.color.light.shade};
`;

export const AuthFormWrapper = styled.div`
  width: 100%;
  max-width: 450px;
`;

export const InfoIconWrapper = styled.div`
  margin-top: 5px;
  margin-right: 7px;
  display: inline-block;
`;

export const RecapCardWrapper = styled.div`
  position: sticky;
  top: 130px;
  min-width: 370px;
  background: white;
  border-radius: 8px;
  margin-left: 20px;
  padding: 30px;
  margin-right: 10px;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);

  ${mediaQuery('desktop')} {
    max-width: 300px;
  }

  ${mediaQuery('medium')} {
    margin: 0;
    margin-top: 20px;
    max-width: 100%;
    width: 100%;
    min-width: auto;
  }

  ${mediaQuery('small')} {
    padding: 20px;
  }
`;

export const RecapContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RecapTitle = styled.h4`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 5px;
  color: ${(props) => props.theme.color.blue.default};
  white-space: break-spaces;
`;

export const RecapCardDateTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 5px;
  white-space: break-spaces;
  font-size: 22px;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 20px;
  color: ${(props) => props.theme.color.blue.default};
`;

export const RecapProfileWrapper = styled(Value)`
  border-top: 1px solid ${(props) => props.theme.color.light.shade};
  margin-bottom: 0;
  margin: 0 -30px;
  padding: 20px 30px;
  margin-bottom: 0;
  padding-bottom: 0;
  flex-wrap: nowrap;
`;

export const RecapProfileImg = styled.img`
  object-fit: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 15px;
`;

//
// Summary
//

export const SummaryCardContainer = styled(Container)`
  position: relative;
  margin-top: -50px;
  z-index: 1;
  width: 90%;
  max-width: 700px;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  & > *:not(:last-child) {
    margin-bottom: 30px;
  }

  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);
  background: white;
`;

export const SummaryWrapper = styled.div`
  border-top: 1px solid ${(props) => props.theme.color.light.shade};
  margin: 0 -30px;
  padding: 0 30px;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
`;

export const SummaryButtonContainer = styled.div`
  display: flex;
  & > *:not(:last-child) {
    margin-right: 10px;
  }

  ${mediaQuery('small')} {
    & > *:not(:last-child) {
      margin-right: 0;
      margin-bottom: 10px;
    }
    flex-direction: column;
  }
`;

export const SummaryInfoTitle = styled.h4`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
  white-space: break-spaces;
`;

export const SummaryInfoTitleAnimal = styled.h4`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 20px;
  white-space: break-spaces;
`;

export const AnimalAccordionTabContent = styled.div`
  padding: 20px 30px;

  ${mediaQuery('small')} {
    padding: 15px;
  }
`;

export const AnimalAccordionTabWrapper = styled.div`
  display: flex;
  align-items: center;
  & > *:not(:last-child) {
    margin-right: 10px;
  }
`;

export const AnimalAddButton = styled(Button)`
  height: auto;
  line-height: auto;
  padding: 0;
`;
